import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import type { OverlayContentProps } from '../Overlay';
import { OverlayContent } from '../Overlay';

const DrawerContent = forwardRef<HTMLDivElement, OverlayContentProps>(
  ({ children, scroll, p = 'base', ...rest }, ref) => {
    return (
      <OverlayContent ref={ref} scroll={scroll} p={p} {...rest}>
        {children}
      </OverlayContent>
    );
  }
);

DrawerContent.propTypes = {
  children: PropTypes.any,
  scroll: PropTypes.bool,
};

export default DrawerContent;
